import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const StyledButtonWrapper = styled.div`
  cursor: pointer;
  height: 24px;
  width: 24px;

  margin-right: 8px;

  :hover {
    color: ${globals.TEAL_550};
  }
`;
